export default function shuffleArray(arr) {
  console.log("In shuffleArray...");

  // Fisher-Yates (aka Knuth) Shuffle from ChatGPT
  let shuffledArray = [...arr];

  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]]; // Swap elements
  }

  return shuffledArray;
}
